export const ZENDESK_SETTINGS_BY_PLAN = {
	free: (name, email) => ({
		webWidget: {
			color: { theme: '#7D7AFF' },
			helpCenter: {
				originalArticleButton: false,
				suppress: false, //KB pre-question
			},
			chat: {
				suppress: false,
			},
			launcher: {
				label: {
					'*': '',
				},
				chatLabel: {
					'*': '',
				},
			},
			contactForm: {
				title: { '*': 'Send Us an Email' },
				fields: [
					{ id: 'name', prefill: { '*': name } },
					{ id: 'email', prefill: { '*': email } },
				],
			},
		},
	}),
	enterprise: (name, email) => ({
		webWidget: {
			color: { theme: '#7D7AFF' },
			helpCenter: {
				originalArticleButton: false,
				suppress: true, //No KB pre-question
			},
			chat: {
				suppress: false,
			},
			launcher: {
				label: {
					'*': '',
				},
				chatLabel: {
					'*': '',
				},
			},
			contactForm: {
				title: { '*': 'Send Us an Email' },
				fields: [
					{ id: 'name', prefill: { '*': name } },
					{ id: 'email', prefill: { '*': email } },
				],
			},
			contactOptions: {
				enabled: true,
				contactFormLabel: { '*': 'Send Us an Email' },
			},
		},
	}),
	paid: (name, email) => ({
		webWidget: {
			color: { theme: '#7D7AFF' },
			helpCenter: {
				originalArticleButton: false,
				suppress: false, //KB pre-question
			},
			chat: {
				suppress: false,
			},
			launcher: {
				label: {
					'*': '',
				},
				chatLabel: {
					'*': '',
				},
			},
			contactForm: {
				title: { '*': 'Send Us an Email' },
				fields: [
					{ id: 'name', prefill: { '*': name } },
					{ id: 'email', prefill: { '*': email } },
				],
			},
			contactOptions: {
				enabled: true,
				contactFormLabel: { '*': 'Send Us an Email' },
			},
		},
	}),
	anonymous: () => ({
		webWidget: {
			color: { theme: '#7D7AFF' },
			helpCenter: {
				originalArticleButton: false,
				suppress: false, //KB pre-question
			},
			chat: {
				suppress: false,
			},
			launcher: {
				label: {
					'*': '',
				},
				chatLabel: {
					'*': '',
				},
			},
			contactForm: {
				title: { '*': 'Send Us an Email' },
			},
			contactOptions: {
				enabled: true,
				contactFormLabel: { '*': 'Send Us an Email' },
			},
		},
	}),
};
